require('./style.less');


var Marionette = require('marionette'),
    PreventDragEventsMixin = require('../preventDragEventsMixin');

// These are actually collection views ... rename as such ...
var ZoneLayer = require('./zoneLayer/zoneLayer'),
    LineLayer = require('./lineLayer/lineLayer'),
    WordLayer = require('./wordLayer/wordLayer');

var DEBUG_MODE = 1;

if ( PRODUCTION ) {
    DEBUG_MODE = 0;
}

// For now a flag to create these layers.
// Maybe later they become an option if desired but currently don't have a use for them.
// Main goal now if find and redact portion.
// For now these are more useful for debugging for development.
var CREATE_ZONE_LAYER = 1;
var CREATE_LINE_LAYER = 1;


module.exports = Marionette.LayoutView.extend({

    className: 'FV-page-text-layer',

    template: require('./template.hbs'),

    initialize: function( options ) {

        this.page = options.page;
        this.positionalTextDataModel = options.pagePositionalTextModel;


        this.zoneLayer = null;
        this.lineLayer = null;
        this.wordLayer = null;

        this.wordResultViews = null; // now created from those existing ... should prob be another layer ... need to get flow for saving, etc

    },

    //regions: {
    //    zoneRegion:  '.layer-zone',
    //    lineRegion:  '.layer-line'
    //},

    // May want regions for easier management
    ui: {
        zoneLayer:  '.layer-zone',
        lineLayer:  '.layer-line',
        wordLayer:  '.layer-word'
    },

    events: _.extend( {}, PreventDragEventsMixin, {

    }),

    onRender: function() {

        if ( DEBUG_MODE ) {
            this.$el.addClass('FV-page-text-layer-debug');
        }

        // could decide whether we even want the extra models ... could just utilize data in the DOM ..
        // EG: we search on another layer, do we ever care about these ???
        if ( CREATE_ZONE_LAYER )
            this.createZoneLayer( );


       if ( CREATE_LINE_LAYER )
            this.createLineLayer( );

        this.createWordLayer( );

    },

    // TODO could be a collection / baby sitter  (collection inherits ) view if need to access via model, not markup now ... or collection view
    // Model here would be the zone
    // maybe just do a babysitter view ...
    createZoneLayer: function() {

        this.zoneLayer = new ZoneLayer({
            collection: this.positionalTextDataModel.getZones(),
            el: this.ui.zoneLayer,
            sort: false // for perf gains ... but do outside Marionette prob faster
        });

        // TODO: want to make sure its in the buffer ... but at least nothing yet in the DOM ...
        this.zoneLayer.render();

        //this.zoneRegion.show( this.zoneLayer ); // Note: if use regions, use get extra div ...
    },

    createLineLayer: function() {

        // TODO: test with new font metrics coming from real data ...

        this.lineLayer = new LineLayer({
            collection: this.positionalTextDataModel.getLines(),
            el: this.ui.lineLayer,
            sort: false // for perf gains ... but do outside Marionette prob faster
        });

        // TODO: want to make sure its in the buffer ... but at least nothing yet in the DOM ...
        this.lineLayer.render();

        //this.lineRegion.show( this.lineLayer );
    },


    // Note: these are really collections
    createWordLayer: function(  ) {

        // TODO:
        // - this should go prior to render of the collection view
        // - cache
        var spacer =  document.createElement('span');
        spacer.style['font-family'] = this.positionalTextDataModel.getFont();
        spacer.className = 'offScreen';
        document.body.appendChild( spacer );

        this.wordLayer = new WordLayer({
            el: this.ui.wordLayer,
            collection: this.positionalTextDataModel.getWords(),
            spacer: spacer,
            sort: false // for perf gains ... but do outside Marionette prob faster
        });

        this.wordLayer.render();

        document.body.removeChild( spacer );

    },


    // TODO: this doesn't seem like the way to go: now trying to draw on the canvas ...
    // May want to leave something like this on doc mode but likely in a different view in a layer above the canvas

    showFindAndRedactHits: function( pageResults ) {
/*

        // shapeViews: new Backbone.ChildViewContainer()
        // iF create collection: want new view anyway -- DON'T NEED THIS: DO ANOTHER LAYER ...
        // I suppose could have a collection view in Doc Mode we render the text layer before the image ....

        if ( this.wordResultViews ) {
            this.wordResultViews.each( function(view) {

                view.$el.removeClass('hit');
                this.wordResultViews.remove(view);

            }, this);
        }

        // do we even need this ?
        this.wordResultViews = new Backbone.ChildViewContainer();

        _.each( pageResults, function(pageResult) {

            // with this model, not necessary -- the view already exists
            // also todo: could have diff zones per model if > 1 word ...
            // if go this route, could have hit ui model for the word to link them ....
            // now starting to think we create new ones ( linked by the hit models ) ... this isn't good

            // Also -- don't use findByModel -- in full page mode we are looking at docModelPage
           // var view = this.wordLayer.children.findByModel( pageResult.attributes.words[0] );

            var view =
                this.wordLayer.children.find( function(v) { return v.model.attributes.id ===  pageResult.attributes.words[0].id; }); // hack to get workin on page model with has diff model

            // TODO: should also link it to the hit ...
            view.$el.addClass('hit'); // this is just for testing now ...

            this.wordResultViews.add( view );

        }, this);
*/


    },

    onBeforeDestroy: function() {

        this.zoneLayer && this.zoneLayer.destroy();
        this.lineLayer && this.lineLayer.destroy();
        this.wordLayer && this.wordLayer.destroy();

    }


});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/textLayer/view.js
 ** module id = 440
 ** module chunks = 0
 **/